import React from 'react'

export default function MiniKpi({ label, value, hint }) {
  return (
    <div title={hint} style={{ padding: '10px 12px', borderRadius: 12, background: 'var(--bg-raised)', minWidth: 0 }}>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, lineHeight: 1.3 }}>
        {label}
      </div>
      <div className="pw-num" style={{ fontSize: 16, fontWeight: 700, color: 'var(--text-primary)', marginTop: 2 }}>
        {value}
      </div>
    </div>
  )
}
